import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

class Article extends Component {
  render() {
    const { classes, showPrice } = this.props;

    const features = this.props.value.features
      ? <Typography className={classes.features} color="textSecondary">{this.props.value.features.join(', ')}</Typography>
      : null;

    const note = this.props.value.note
      ? <Typography className={classes.note}>{this.props.value.note}</Typography>
      : null;

    return (
      <div className={classes.root}>
        <div className={classes.articleContainer}>
          <Typography className={classes.quantity}>{this.props.value.quantity}</Typography>
          <Typography className={classes.name}>{this.props.value.name}</Typography>
          {showPrice ?
            <Typography className={classes.price}>{this.props.value.price.toFixed(2).replace('.', ',')}€</Typography>
            : null}
        </div>
        {features}
        {note}
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    width: "100%",
  },
  articleContainer: {
    display: 'flex',
    flex: 1,
    width: "100%",
    justifyContent: "space-between",
  },
  quantity: {
    width: theme.article.quantityWidth,
  },
  name: {
    flex: 10,
  },
  price: {
    flex: 1,
  },
  features: {
    marginLeft: theme.article.quantityWidth,
  },
  note: {
    color: theme.palette.error.dark,
    marginLeft: theme.article.quantityWidth,
  },
});

Article.propTypes = {
  value: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Article);
